<cheelee-info-block
  [action]="actionFn"
  [actionBtnText]="actionBtnText"
  [message]="messageText!"
  [variant]="variant"
  isSnackbarMode
/>
